import * as Config from '../../../config';
import React from 'react';
import PropTypes from 'prop-types';

// import MidDropBox from '../dnd/MidDropBox';
import CoverSplit from '../common/CoverSplit';
import More from '../common/More';

import useFullPlaylistMenu from './hooks/useFullPlaylistMenu';

function PlaylistMenu({
  playlist, index, style, draggable = false,
  name, track_count, length_ms = null
}) {

  const {
    match, setHistory,
    availableDrop, opacity, refDrop,
    deleteFormPlaylist,
    id, to, cover, showContextMenu, onRightClick
  } = useFullPlaylistMenu(playlist);

  return (
    <div className={`menu-left-container ${match && `selected`} `} onContextMenu={onRightClick} >
      <div id={`PM-D-${id}`} onClick={deleteFormPlaylist} />
      <div id={`link-ref-${id}`} onClick={setHistory} style={{textDecoration: `none`}} to={to}>
        <div id={`ref-${id}`} className={`playlist-container ${match && `selected`} ${availableDrop && `droppable`} `} ref={refDrop} style={{
          display: `flex`, flexDirection: `row`, flexWrap: `nowrap`, alignContent: `flex-start`, justifyContent: `flex-start`,
          ...style, opacity, cursor: (availableDrop) ? `copy` : `default`
        }} >
          <CoverSplit name={name} images={cover} size={Config.MENU_COVER_SIZE} />
          <div className={`flexColumn playlist-menu-infos type-small`}>
            <span className={`type-medium fz13 type-light`} ref={null /*dragRef*/} >{Config.limitString(name, 15 /*22*/, false)}</span>
            <span className={`playlist-menu-owner`}>{`${track_count} tracks • ${Config.msToHourMin(length_ms)}`}</span>
          </div>
          { /* isDraggingPlaylists && (
            <>
              <MidDropBox accept={[`PLAYLIST-MENU`]} drop={onReorder(index - 1)} style={{ ...styleMidDropBox, top: 0, borderTop: `1px solid ${Config.BRAND_PRIMARY}` }} />
              <MidDropBox accept={[`PLAYLIST-MENU`]} drop={onReorder(index)} style={{ ...styleMidDropBox, bottom: 0, borderBottom: `1px solid ${Config.BRAND_PRIMARY}` }} />
            </>
          ) */ }
        </div>
      </div>
      <More id={`more-ref-${id}`} size={24} className={`playlist-more`} onClick={showContextMenu} />
    </div>
  )
}

PlaylistMenu.propTypes = {
  playlist: PropTypes.object.isRequired,
  index: PropTypes.number,
  style: PropTypes.object,
  name: PropTypes.string,
  track_count: PropTypes.number,
  draggable: PropTypes.bool,
}

export default PlaylistMenu;
